import { render, staticRenderFns } from "./PricingCounter.vue?vue&type=template&id=ab5d58c8&scoped=true"
import script from "./PricingCounter.vue?vue&type=script&lang=js"
export * from "./PricingCounter.vue?vue&type=script&lang=js"
import style0 from "./PricingCounter.vue?vue&type=style&index=0&id=ab5d58c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5d58c8",
  null
  
)

export default component.exports